import { render } from "./text-media.vue?vue&type=template&id=0b865f7c"
import script from "./text-media.vue?vue&type=script&lang=js"
export * from "./text-media.vue?vue&type=script&lang=js"

import "./text-media.vue?vue&type=style&index=0&id=0b865f7c&lang=scss"

import exportComponent from "/Users/riccardosirchia/Projects/dryrobe.com-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__